export default [
  //fullpages
  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
      onlyUser: true,
      onlyAdmin: true,
      onlyPartner: true,
    },
  },
  {
    path: "/pages/miscellaneous/coming-soon",
    name: "misc-coming-soon",
    component: () => import("@/views/pages/miscellaneous/ComingSoon.vue"),
    meta: {
      layout: "full",
      onlyUser: true,
      onlyAdmin: true,
      onlyPartner: true,
    },
  },
  {
    path: "/pages/miscellaneous/not-authorized",
    name: "misc-not-authorized",
    component: () => import("@/views/pages/miscellaneous/NotAuthorized.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/pages/miscellaneous/under-maintenance",
    name: "misc-under-maintenance",
    component: () => import("@/views/pages/miscellaneous/UnderMaintenance.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/pages/miscellaneous/error",
    name: "misc-error",
    component: () => import("@/views/pages/miscellaneous/Error.vue"),
    meta: {
      layout: "full",
    },
  },
  //fullpages
  //auth
  {
    path: "",
    component: () => import("@/views/panel/auth/login/Login.vue"),
    children: [
      {
        path: "/auth/user/login",
        name: "auth-user-login",
        component: () => import("@/views/panel/auth/login/UserLogin.vue"),
        meta: {
          layout: "full",
          resource: "Auth",
          redirectIfLoggedIn: true,
        },
      },
      {
        path: "/auth/partner/login",
        name: "auth-partner-login",
        component: () => import("@/views/panel/auth/login/PartnerLogin.vue"),
        meta: {
          layout: "full",
          resource: "Auth",
          redirectIfLoggedIn: true,
        },
        afterEach(to, from) {
          if (this.$store.state.auth.userData.status === "PENDING") {
            to.name = "partner-registration-step1";
          }
        },
      },
    ],
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "",
    component: () => import("@/views/panel/auth/register/Register.vue"),
    children: [
      {
        path: "/auth/user/register",
        name: "auth-user-register",
        component: () => import("@/views/panel/auth/register/UserRegister.vue"),
        meta: {
          layout: "full",
          resource: "Auth",
          redirectIfLoggedIn: true,
        },
      },
      {
        path: "/auth/user/email/verify",
        name: "auth-user-email-verify",
        component: () =>
          import("@/views/panel/auth/register/UserEmailVerify.vue"),
        meta: {
          layout: "full",
          resource: "Auth",
          onlyUser: true,
          onlyAdmin: true,
        },
      },
    ],
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "",
    component: () =>
      import("@/views/panel/auth/forgot-password/ForgotPassword.vue"),
    children: [
      {
        path: "/auth/user/forgot-password",
        name: "auth-user-forgot-password",
        component: () =>
          import("@/views/panel/auth/forgot-password/UserForgotPassword.vue"),
        meta: {
          layout: "full",
          resource: "Auth",
          redirectIfLoggedIn: true,
        },
      },
      {
        path: "/auth/user/reset-password/:token",
        name: "auth-user-reset-password",
        component: () =>
          import("@/views/panel/auth/forgot-password/UserResetPassword.vue"),
        meta: {
          layout: "full",
          resource: "Auth",
          redirectIfLoggedIn: true,
        },
      },
      {
        path: "/auth/partner/forgot-password",
        name: "auth-partner-forgot-password",
        component: () =>
          import(
            "@/views/panel/auth/forgot-password/PartnerForgotPassword.vue"
          ),
        meta: {
          layout: "full",
          resource: "Auth",
          redirectIfLoggedIn: true,
        },
      },
      {
        path: "/auth/partner/reset-password/:token",
        name: "auth-partner-reset-password",
        component: () =>
          import("@/views/panel/auth/forgot-password/PartnerResetPassword.vue"),
        meta: {
          layout: "full",
          resource: "Auth",
          redirectIfLoggedIn: true,
        },
      },
    ],
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/partner-registration",
    component: () =>
      import("@/views/panel/partner-registration/PartnerRegistration.vue"),
    meta: {
      onlyPartner: true,
    },

    children: [
      {
        path: "step1",
        name: "partner-registration-step1",
        component: () =>
          import("@/views/panel/partner-registration/step1/Step1.vue"),
        meta: {
          onlyPartner: true,
        },
      },
      {
        path: "step2",
        name: "partner-registration-step2",
        component: () =>
          import("@/views/panel/partner-registration/step2/Step2.vue"),

        meta: {
          onlyPartner: true,
        },
      },
      {
        path: "step3",
        name: "partner-registration-step3",
        component: () =>
          import("@/views/panel/partner-registration/step3/Step3.vue"),

        meta: {
          onlyPartner: true,
        },
      },
    ],
  },
  //auth
  //dashboards
  {
    path: "/partner-dashboard",
    name: "partner-dashboard",
    component: () =>
      import("@/views/panel/partner-dashboard/PartnerDashboard.vue"),
    meta: {
      onlyPartner: true,
    },
  },
  {
    path: "/user-dashboard",
    name: "user-dashboard",
    component: () => import("@/views/panel/user-dashboard/UserDashboard.vue"),
    meta: {
      onlyUser: true,
      onlyAdmin: true,
    },
  },
  {
    path: "/all-time-analytics",
    name: "all-time-analytics",
    component: () =>
      import("@/views/panel/all-time-analytics/AllTimeAnalytics.vue"),
    meta: {
      onlyPartner: true,
      onlyAdmin: true,
    },
  },
  //dashboards

  //wallet
  {
    path: "/account/withdraw",
    name: "account-withdraw",
    component: () =>
      import("@/views/panel/financial/checkouts/account/AccountForm.vue"),
    meta: {
      onlyAdmin: true,
      onlyPartner: true,
      onlyUser: true,
    },
  },
  {
    path: "",
    name: "wallet",
    component: () => import("@/views/panel/wallet/Wallet.vue"),
    children: [
      {
        path: "/wallet",
        name: "wallet-overview",
        component: () => import("@/views/panel/wallet/Overview.vue"),
        meta: {
          onlyAdmin: true,
          onlyPartner: true,
          onlyUser: true,
        },
      },
      {
        path: "/competitions/:id/wallet",
        name: "competition-wallet-overview",
        component: () => import("@/views/panel/wallet/Overview.vue"),
        meta: {
          onlyAdmin: true,
          onlyPartner: true,
          onlyUser: true,
        },
      },
      {
        path: "/users/:id/wallet",
        name: "user-wallet-overview",
        component: () => import("@/views/panel/wallet/Overview.vue"),
        meta: {
          onlyAdmin: true,
        },
      },
      {
        path: "/partners/:id/wallet",
        name: "partner-wallet-overview",
        component: () => import("@/views/panel/wallet/Overview.vue"),
        meta: {
          onlyAdmin: true,
        },
      },
      {
        path: "/plans/:id/wallet",
        name: "plan-wallet-overview",
        component: () => import("@/views/panel/wallet/Overview.vue"),
        meta: {
          onlyAdmin: true,
        },
      },
      {
        path: "/wallet/withdraw",
        name: "wallet-withdraw",
        component: () => import("@/views/panel/wallet/withdraw/Withdraw.vue"),
        meta: {
          onlyAdmin: true,
          onlyPartner: true,
          onlyUser: true,
        },
      },

      {
        path: "/competitions/:id/withdraw",
        name: "competition-wallet-withdraw",
        component: () => import("@/views/panel/wallet/withdraw/Withdraw.vue"),
        meta: {
          onlyAdmin: true,
          onlyPartner: true,
          onlyUser: true,
        },
      },
      {
        path: "/users/:id/withdraw",
        name: "user-wallet-withdraw",
        component: () => import("@/views/panel/wallet/withdraw/Withdraw.vue"),
        meta: {
          onlyAdmin: true,
        },
      },
      {
        path: "/partners/:id/withdraw",
        name: "partner-wallet-withdraw",
        component: () => import("@/views/panel/wallet/withdraw/Withdraw.vue"),
        meta: {
          onlyAdmin: true,
        },
      },
      {
        path: "/plans/:id/withdraw",
        name: "plan-wallet-withdraw",
        component: () => import("@/views/panel/wallet/withdraw/Withdraw.vue"),
        meta: {
          onlyAdmin: true,
        },
      },
      {
        path: "/wallet/deposit",
        name: "wallet-deposit",
        component: () => import("@/views/panel/wallet/deposit/Deposit.vue"),
        meta: {
          onlyAdmin: true,
          onlyPartner: true,
          onlyUser: true,
        },
      },
      {
        path: "/competitions/:id/deposit",
        name: "competition-wallet-deposit",
        component: () => import("@/views/panel/wallet/deposit/Deposit.vue"),
        meta: {
          onlyAdmin: true,
          onlyPartner: true,
          onlyUser: true,
        },
      },
      {
        path: "/users/:id/deposit",
        name: "user-wallet-deposit",
        component: () => import("@/views/panel/wallet/deposit/Deposit.vue"),
        meta: {
          onlyAdmin: true,
        },
      },
      {
        path: "/partners/:id/deposit",
        name: "partner-wallet-deposit",
        component: () => import("@/views/panel/wallet/deposit/Deposit.vue"),
        meta: {
          onlyAdmin: true,
        },
      },
      {
        path: "/plans/:id/deposit",
        name: "plan-wallet-deposit",
        component: () => import("@/views/panel/wallet/deposit/Deposit.vue"),
        meta: {
          onlyAdmin: true,
        },
      },
      {
        path: "/wallet/transactions",
        name: "wallet-transactions",
        component: () => import("@/views/panel/wallet/Transactions.vue"),
        meta: {
          onlyAdmin: true,
          onlyPartner: true,
          onlyUser: true,
        },
      },
      {
        path: "/competitions/:id/transactions",
        name: "competition-wallet-transactions",
        component: () => import("@/views/panel/wallet/Transactions.vue"),
        meta: {
          onlyAdmin: true,
          onlyPartner: true,
          onlyUser: true,
        },
      },
      {
        path: "/users/:id/transactions",
        name: "user-wallet-transactions",
        component: () => import("@/views/panel/wallet/Transactions.vue"),
        meta: {
          onlyAdmin: true,
        },
      },
      {
        path: "/partners/:id/transactions",
        name: "partner-wallet-transactions",
        component: () => import("@/views/panel/wallet/Transactions.vue"),
        meta: {
          onlyAdmin: true,
        },
      },
      {
        path: "/plans/:id/transactions",
        name: "plan-wallet-transactions",
        component: () => import("@/views/panel/wallet/Transactions.vue"),
        meta: {
          onlyAdmin: true,
        },
      },
    ],
  },
  //wallet
  //accounts
  {
    path: "/accounts",
    name: "accounts",
    component: () => import("@/views/panel/accounts/Accounts.vue"),
    meta: {
      onlyAdmin: true,
      onlyUser: true,
    },
  },
  {
    path: "/accounts/create",
    name: "accounts-create",
    component: () =>
      import("@/views/panel/accounts/accounts-form/AccountsForm.vue"),
    meta: {
      onlyAdmin: true,
      onlyUser: true,
    },
  },
  {
    path: "/accounts/edit/:id",
    name: "accounts-edit",
    component: () =>
      import("@/views/panel/accounts/accounts-form/AccountsForm.vue"),
    meta: {
      onlyAdmin: true,
      onlyUser: true,
    },
  },
  //accounts
  //categories
  {
    path: "/categories",
    name: "categories",
    component: () => import("@/views/panel/categories/Categories.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/categories/create",
    name: "categories-create",
    component: () =>
      import("@/views/panel/categories/categories-form/categoriesForm.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/categories/edit/:id",
    name: "categories-edit",
    component: () =>
      import("@/views/panel/categories/categories-form/categoriesForm.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  //categories
  //partners
  {
    path: "/partners",
    name: "partners",
    component: () => import("@/views/panel/partners/Partners.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/partners/edit/profile",
    name: "partners-edit-profile",
    component: () =>
      import("@/views/panel/partners/partners-form/partnersForm.vue"),
    meta: {
      onlyPartner: true,
    },
  },
  {
    path: "/partners/edit/:id",
    name: "partners-edit",
    component: () =>
      import("@/views/panel/partners/partners-form/partnersForm.vue"),
    meta: {
      onlyAdmin: true,
    },
  },

  //partners
  //users
  {
    path: "/users",
    name: "users",
    component: () => import("@/views/panel/users/Users.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/users/create",
    name: "users-create",
    component: () => import("@/views/panel/users/users-form/UsersForm.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/user/edit/profile",
    name: "users-edit-profile",
    component: () => import("@/views/panel/users/users-form/UsersForm.vue"),
    meta: {
      onlyAdmin: true,
      onlyUsers: true,
    },
  },
  {
    path: "/users/edit/:id",
    name: "users-edit",
    component: () => import("@/views/panel/users/users-form/UsersForm.vue"),
    meta: {
      onlyAdmin: true,
    },
  },

  //users
  //sponsors
  {
    path: "/sponsors",
    name: "sponsors",
    component: () => import("@/views/panel/sponsors/Sponsors.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/sponsors/create",
    name: "sponsors-create",
    component: () =>
      import("@/views/panel/sponsors/sponsors-form/SponsorsForm.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/sponsors/edit/:id",
    name: "sponsors-edit",
    component: () =>
      import("@/views/panel/sponsors/sponsors-form/SponsorsForm.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  //sponsors
  //documents
  {
    path: "/documents",
    name: "documents",
    component: () => import("@/views/panel/documents/Documents.vue"),
    meta: {
      onlyAdmin: true,
      onlyPartner: true,
      onlyUser: true,
    },
  },
  {
    path: "/documents/:id",
    name: "documents-show",
    component: () =>
      import("@/views/panel/documents/admin/documents-show/DocumentsShow.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/documents/create",
    name: "documents-create",
    component: () =>
      import(
        "@/views/panel/documents/partners/documents-form/DocumentsForm.vue"
      ),
    meta: {
      onlyPartner: true,
      onlyUser: true,
    },
  },
  {
    path: "/documents/edit/:id",
    name: "documents-edit",
    component: () =>
      import(
        "@/views/panel/documents/partners/documents-form/DocumentsForm.vue"
      ),
    // meta: {
    //   onlyPartner: true,
    //   onlyUser: true,
    // },
  },
  //documents
  //brokers
  {
    path: "/brokers",
    name: "brokers",
    component: () => import("@/views/panel/brokers/Brokers.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/brokers/create",
    name: "brokers-create",
    component: () =>
      import("@/views/panel/brokers/brokers-form/BrokersForm.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/brokers/edit/:id",
    name: "brokers-edit",
    component: () =>
      import("@/views/panel/brokers/brokers-form/BrokersForm.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  //brokers
  //protests
  {
    path: "/protests",
    name: "protests",
    component: () => import("@/views/panel/protests/Protests.vue"),
    meta: {
      onlyAdmin: true,
      onlyPartner: true,
    },
  },
  // {
  //   path: "/protests/create",
  //   name: "protests-create",
  //   component: () =>
  //     import("@/views/panel/protests/protests-form/ProtestsForm.vue"),
  //   meta: {
  //     onlyAdmin: true,
  //     onlyPartner: true,
  //   },
  // },
  // {
  //   path: "/protests/edit/:id",
  //   name: "protests-edit",
  //   component: () =>
  //     import("@/views/panel/protests/protests-form/ProtestsForm.vue"),
  //   meta: {
  //     onlyAdmin: true,
  //   },
  // },
  //protests
  //competitions
  {
    path: "/competitions",
    name: "competitions",
    component: () => import("@/views/panel/competitions/Competitions.vue"),
    meta: {
      onlyAdmin: true,
      onlyPartner: true,
      onlyUser: true,
    },
  },
  {
    path: "/competitions/create",
    name: "create-competition",
    component: () =>
      import("@/views/panel/competitions/competition-form/CompetitionForm.vue"),
    meta: {
      onlyAdmin: true,
      onlyPartner: true,
    },
  },
  {
    path: "/competitions/edit/:id",
    name: "edit-competitions",
    component: () =>
      import("@/views/panel/competitions/competition-form/CompetitionForm.vue"),
    meta: {
      onlyAdmin: true,
      onlyPartner: true,
    },
  },
  // {
  //   path: "/competitions/:id/manage",
  //   name: "manage-competition",
  //   component: () =>
  //     import(
  //       "@/views/panel/competitions/competition-manage/CompetitionManage.vue"
  //     ),
  // },
  {
    path: "/competitions/:id/live",
    name: "live-competition",
    component: () =>
      import("@/views/panel/competitions/competition-live/CompetitionLive.vue"),
    meta: {
      onlyAdmin: true,
      onlyPartner: true,
    },
  },
  {
    path: "/competitions/:id",
    name: "show-competition",
    component: () =>
      import("@/views/panel/competitions/competition-show/CompetitionShow.vue"),
    meta: {
      notNeedLogin: true,
    },
  },

  {
    path: "/competitions/:id/edit",
    name: "edit-competition",
    component: () =>
      import("@/views/panel/competitions/competition-form/CompetitionForm.vue"),
    meta: {
      onlyAdmin: true,
      onlyPartner: true,
      onlyUser: true,
    },
  },

  //competitions
  //financial
  {
    path: "/financial/transactions",
    name: "financial-transactions",
    component: () =>
      import("@/views/panel/financial/transactions/Transactions.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/financial/transfers",
    name: "financial-transfers",
    component: () => import("@/views/panel/financial/transfers/Transfers.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/financial/checkouts",
    name: "financial-checkouts",
    component: () => import("@/views/panel/financial/checkouts/Checkouts.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  {
    path: "/financial/checkouts/account",
    name: "financial-checkouts-account",
    component: () =>
      import("@/views/panel/financial/checkouts/account/AccountForm.vue"),
    meta: {
      onlyAdmin: true,

      onlyUser: true,
      onlyPartner: true,
    },
  },

  //financial
  //plans
  {
    path: "/plans",
    name: "plans",
    component: () => import("@/views/panel/plans/Plans.vue"),
    meta: {
      onlyAdmin: true,
      onlyPartner: true,
    },
  },
  //plans
  //massages
  {
    path: "/messages",
    name: "messages",
    component: () => import("@/views/panel/messages/messages.vue"),
    meta: {
      onlyAdmin: true,
    },
  },
  //massages
  // Achievments
  {
    path: "/Achievments",
    name: "Achievments",
    component: () =>
      import("@/views/panel/user-dashboard/achivments/Achievments.vue"),
    meta: {
      onlyAdmin: true,
      onlyUser: true,
    },
  },

  // Achievments
];
